import { computed } from "mobx";
import FormStore from "~/stores/FormStore";
import CommonHelper from "~/utils/CommonHelper";

class UiMeet3dNotificationFormStore extends FormStore {
  @computed
  get isDirty() {
    const properties = Object.keys(this.initialModel);
    const modelProperties = Object.keys(this.model);

    for (let i = 0; i < properties.length; i += 1) {
      const property = properties[i];

      // do not compare if the property is not set on the actual model.
      if (modelProperties.indexOf(property) === -1) {
        // eslint-disable-next-line no-continue
        continue;
      }

      // Support for arrays
      if (Array.isArray(this.initialModel[property])) {
        // If it was array and it isn't
        if (!Array.isArray(this.model[property])) {
          return true;
        }

        if (!CommonHelper.equalArrays(this.model[property], this.initialModel[property])) {
          return true;
        }

        // eslint-disable-next-line no-continue
        continue;
      }

      if (this.model[property] !== this.initialModel[property]) {
        return true;
      }
    }

    return false;
  }
}

export default UiMeet3dNotificationFormStore;
